export const ImpersonationServiceTokens = Object.freeze({
    ImpersonationStoreService: Symbol('ImpersonationStoreService'),
    UserImpersonationApi: Symbol('UserImpersonationApi'),
    UserImpersonationService: Symbol('UserImpersonationService'),
} as const);
